import { render, staticRenderFns } from "./CustomerTaxNo.vue?vue&type=template&id=0ed292e8&"
import script from "./CustomerTaxNo.vue?vue&type=script&lang=js&"
export * from "./CustomerTaxNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports